import React, { Component, createRef } from "react";
import { FaAngleLeft } from "react-icons/fa6";
import { FaAngleRight } from "react-icons/fa6";
import LandingReviewCard from "./landing_review_card";

class LandingScrollContainer extends Component {
    state = {
        canScrollLeft: false,
        canScrollRight: true,
        direction: "right",
        step: 432, // card + gap width
      };
    
      scrollRef = createRef();
      autoScrollTimer = null;
    
      componentDidMount() {
        const el = this.scrollRef.current;
        if (!el) return;
    
        this.calculateStep();
        this.checkScroll();
        el.addEventListener("scroll", this.checkScroll);
        window.addEventListener("resize", this.calculateStep);
        this.startAutoScroll();
      }
    
      componentWillUnmount() {
        const el = this.scrollRef.current;
        if (el) {
          el.removeEventListener("scroll", this.checkScroll);
        }
        window.removeEventListener("resize", this.calculateStep);
        if (this.autoScrollTimer) clearInterval(this.autoScrollTimer);
      }
    
      calculateStep = () => {
        const el = this.scrollRef.current;
        if (!el) return;
    
        // assume all cards have same width
        const firstCard = el.querySelector(".card");
        if (firstCard) {
          const cardStyle = window.getComputedStyle(firstCard);
          const cardWidth = firstCard.offsetWidth;
          const gap = parseInt(cardStyle.marginRight || "0", 10) || 16; // fallback
          this.setState({ step: cardWidth + gap });
        }
      };
    
      checkScroll = () => {
        const el = this.scrollRef.current;
        if (!el) return;
    
        this.setState({
          canScrollLeft: el.scrollLeft > 0,
          canScrollRight: el.scrollLeft + el.clientWidth < el.scrollWidth,
        });
      };
    
      scroll = (dir) => {
        const el = this.scrollRef.current;
        if (!el) return;
    
        const { step } = this.state;
        el.scrollBy({
          left: dir === "left" ? -step : step,
          behavior: "smooth",
        });
      };
    
      resetTimer = () => {
        if (this.autoScrollTimer) clearInterval(this.autoScrollTimer);
        this.startAutoScroll();
      };
    
      startAutoScroll = () => {
        this.autoScrollTimer = setInterval(() => {
          const el = this.scrollRef.current;
          if (!el) return;
    
          const { direction, step } = this.state;
    
          if (direction === "right") {
            if (el.scrollLeft + el.clientWidth >= el.scrollWidth) {
              this.setState({ direction: "left" });
              el.scrollBy({ left: -step, behavior: "smooth" });
            } else {
              el.scrollBy({ left: step, behavior: "smooth" });
            }
          } else {
            if (el.scrollLeft <= 0) {
              this.setState({ direction: "right" });
              el.scrollBy({ left: step, behavior: "smooth" });
            } else {
              el.scrollBy({ left: -step, behavior: "smooth" });
            }
          }
        }, 10000);
      };

  render() {
    const { canScrollLeft, canScrollRight } = this.state;
    const { gadget } = this.props;

    const cardList = gadget.length > 0 ? gadget.map( item => {
        return (
            <LandingReviewCard key={item.id} gadget={item} />
        )
    }): null 
 
    return ( 
        <div className="scroller-container">
          <button
            className="scroll-btn left"
            onClick={() => {
              this.scroll("left");
              this.resetTimer();
            }}
            disabled={!canScrollLeft}
          >
            <FaAngleLeft />
          </button>

          <div
            className="card-scroll"
            ref={this.scrollRef}
            onWheel={this.resetTimer}
            onTouchStart={this.resetTimer}
          >
            {cardList}
          </div>

          <button
            className="scroll-btn right"
            onClick={() => {
              this.scroll("right");
              this.resetTimer();
            }}
            disabled={!canScrollRight}
          >
            <FaAngleRight />
          </button>
        </div>
    );
  }
}

export default LandingScrollContainer;
